import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyBlogCategories } from "../../api/apiBlogCategories";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي للتصنيفات (soft delete)
 */
export function useDeleteAllBlogCategories() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllBlogCategoriesMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroyBlogCategories,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete blog categories");
        },
    });

    return {
        deleteAllBlogCategoriesMutate,
        isPending,
    };
}
